export enum SalesPriceDiscountType {
  Jit = 'jit',
  Offpeak = 'offpeak',
  SalePrice = 'sale_price',
}

export type DiscountSet = { [key in SalesPriceDiscountType]?: boolean };
